import { motion } from "framer-motion";
import { fadeUp, revealScale, viewport } from "@/lib/motion";
import { WHY, IMAGES } from "@/lib/data";

export const WhyChoose = () => {
  return (
    <section id="why" data-testid="why-section" className="py-24 md:py-36 bg-navy text-[hsl(var(--background))] overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-24 items-center">
          <div>
            <motion.p variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport}
              className="text-xs font-semibold tracking-[0.25em] uppercase text-gold mb-6">Why Faith &amp; Grace</motion.p>
            <motion.h2 variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} custom={1}
              className="font-serif font-light text-4xl sm:text-5xl leading-tight mb-12">
              A partner who treats your mission as their own.
            </motion.h2>

            <div className="space-y-8">
              {WHY.map((w, i) => (
                <motion.div key={w.title} data-testid={`why-item-${i}`}
                  variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} custom={i}
                  className="flex gap-5 border-b border-[hsl(var(--background)/0.15)] pb-8">
                  <span className="font-serif text-2xl text-gold mt-1">0{i + 1}</span>
                  <div>
                    <h3 className="font-serif text-2xl font-normal mb-2">{w.title}</h3>
                    <p className="text-base font-light leading-relaxed text-[hsl(var(--background)/0.7)]">{w.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          <motion.div variants={revealScale} initial="hidden" whileInView="show" viewport={viewport}
            className="relative aspect-[4/5] overflow-hidden"
            style={{ clipPath: "polygon(0 0, 100% 12%, 100% 100%, 0 88%)" }}>
            <img src={IMAGES.teamMeeting} alt="Team strategy meeting" className="h-full w-full object-cover" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
